import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslations } from "@jti/ui";
import { InputFooter, InputLabel } from "../../partials/form-blocks/FormBlocks";
import "./Checkbox.scss";
const Checkbox = ({ label, id, formConfig, requiredMessage, disclaimer, validationRules, checked }) => {
    const { __ } = useTranslations();
    const defaultState = typeof checked === "string" ? checked === "true" : checked || false;
    const [checkboxState, setCheckboxState] = useState(defaultState);
    const hasErrors = Boolean(formConfig?.errors[id]);
    const handleCheckboxClick = () => {
        setCheckboxState((checkboxState) => !checkboxState);
    };
    const getValidationMessage = () => {
        if (formConfig?.errors[id]?.type === "required") {
            return requiredMessage || __("contact.form.requiredmessage");
        }
    };
    const labelId = id ? `label-${id.replace(/\s+/g, "-")}` : undefined;
    return (_jsxs("div", { className: "input-checkbox", children: [_jsxs("div", { className: "checkbox", onClick: handleCheckboxClick, children: [_jsx("div", { className: "checkbox__input-container", children: _jsx("input", { ...formConfig?.register(id, validationRules), "aria-labelledby": labelId, "data-testid": "checkbox-input", type: "checkbox", className: "checkbox__input", defaultChecked: checkboxState, name: id }) }), _jsx(InputLabel, { label: label, htmlFor: id, id: labelId, required: validationRules?.required })] }), _jsx("div", { children: _jsx(InputFooter, { displayError: hasErrors, disclaimer: disclaimer, message: getValidationMessage() }) })] }));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map